import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { Button } from '@mobi/component-library/Base/Buttons'
import { colors, font, shadow, spacing } from '@mobi/component-library/Foundations'
import { AppRoutes } from '@core/AppRoutes'
import { appHistory } from '@core/Utils/routing/history'
import type { SortFeedLabel } from '@core/Areas/BetLoop/Components/Common/SortFeed/types'

export const SortButtonBar: React.FC<{ onClick(): void; label: SortFeedLabel }> = ({
  onClick,
  label,
}) => {
  const handleSearchProfilesClick = () => {
    appHistory.push(AppRoutes.BetLoopSearchProfiles)
  }
  return (
    <SortFeedButtonWrapperStyled>
      <Button color='tertiary_color' size='xs' onClick={onClick}>
        Sort By:
        <strong>{label}</strong>
        <Icon name='SolidChevronDown' size='1.4rem' />
      </Button>

      <Button
        isIconOnlyButton
        color='tertiary_color'
        data-testid='BetLoop.Search'
        onClick={handleSearchProfilesClick}
      >
        <Icon name='LineUsersPlus' size='2.4rem' />
      </Button>
    </SortFeedButtonWrapperStyled>
  )
}

// ======
// Styles
// ======

const SortFeedButtonWrapperStyled = styled.div({
  height: '5.2rem',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 0.2rem',
  color: colors.lavender['700'],
  backgroundColor: colors.white,
  borderBottom: `1px solid ${colors.neutral[100]}`,
  boxShadow: shadow.xs,
  position: 'relative',
  zIndex: 1,

  '> button:first-of-type': {
    gap: spacing.smx2,

    strong: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: font.weight.semibold,
    },
  },
})
